import { convertField } from '@vue/store/helpers.js';
import fieldTypes from '@assets/data/property-search-field-types';

export default {
  props: {
    activeFilters: { type: Array },
  },
  computed: {
    priceType(){
      return (this.searchType == 'for-rent' && this.isSearch) ? 'rent_amt' : 'asking_price';
    },
  },
  methods: {
        
    cleanParams(params){
      const cleaned = {...params};
      const errors = [];
      let keys = Object.keys(params);

      // console.log(cleaned);

      if(keys.includes('min_asking_price')){
        cleaned.min_asking_price = parseFloat(cleaned.min_asking_price) || '';
      }
      if(keys.includes('max_asking_price')){
        cleaned.max_asking_price = parseFloat(cleaned.max_asking_price) || '';
      }
      if(keys.includes('min_beds')){
        cleaned.min_beds = parseFloat(cleaned.min_beds) || '';
      }
      if(keys.includes('max_beds')){
        cleaned.max_beds = parseFloat(cleaned.max_beds) || '';
      }

      // console.log(cleaned);

      return cleaned;
    },
    /* This method will trigger the fetching of new properties */
    emitFilterChange(params){
      let obj = {};
      let fieldName = Object.keys(params)[0];
      let value = Object.values(params)[0];
      let readingIn = false;
      obj[fieldName] = convertField(fieldTypes, fieldName, value, readingIn);
      // console.log({fieldTypes, fieldName, value});
      // console.log(obj);
      this.$emit('filter-change', obj);
    },
    /* This method should -NOT- trigger the fetching of new properties */
    onFilterUpdate(params){
      this.$emit('filter-update', this.cleanParams(params));
    },
        
  }
};